import { render } from "./DocumentStatus.vue?vue&type=template&id=5010118e"
import script from "./DocumentStatus.vue?vue&type=script&lang=js"
export * from "./DocumentStatus.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__